import { configureStore } from "@reduxjs/toolkit";
import customersReducer from "./slices/CustomersSlice";

export default configureStore({
  reducer: {
    customers: customersReducer,
  },
});
